export const PARTNERS = [
    {
        id: 0,
        image: '/images/partners/partner1.png'
    },
    {
        id: 1,
        image: '/images/partners/partner2.png'
    },
    {
        id: 2,
        image: '/images/partners/partner3.png'
    },
    {
        id: 3,
        image: '/images/partners/partner4.png'
    },
    {
        id: 4,
        image: '/images/partners/partner5.png'
    },
    {
        id: 5,
        image: '/images/partners/partner6.png'
    },
    {
        id: 6,
        image: '/images/partners/partner7.png'
    },
    {
        id: 7,
        image: '/images/partners/partner8.png'
    },
    {
        id: 8,
        image: '/images/partners/partner9.png'
    }
]